import React from 'react';
import { observer } from 'mobx-react-lite';
import { DragHandleHorizontalIcon } from '@radix-ui/react-icons';
import { ElevatedButton } from '@producer/ui-kit';

import { TaskLevel } from '../../../app/entities';
import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { taskGroupingStore } from '../../../core/stores/task-store';
import { getActiveGroupBy, getTaskGroupingOptions } from '../task-grouping-options';

type GroupingDropdownProps = {
  taskLevel: TaskLevel;
};

/**
 * The "Group by" dropdown shared by the task list toolbar and the tasks view
 * toolbar. Reads / writes `taskGroupingStore.groupBy`.
 */
export const GroupingDropdown: React.FC<GroupingDropdownProps> = observer(({ taskLevel }) => {
  const options = getTaskGroupingOptions(taskLevel);
  const groupBy = getActiveGroupBy(taskLevel);

  const items = options.map((option) => ({
    title: option.label,
    onCheckedChange: () => {
      if (taskGroupingStore.groupBy !== option.key) {
        taskGroupingStore.setGroupBy(option.key);
      }
    },
    isChecked: groupBy.key === option.key,
  }));

  return (
    <DropdownMenu
      items={items}
      trigger={
        <div>
          <ElevatedButton text="Grouping" icon={<DragHandleHorizontalIcon />} />
        </div>
      }
    />
  );
});
